import React from 'react'
import classnames from 'classnames'
import { Tooltip } from 'antd'
import './index.less'

const Index = ({ overlayClassName, children, placement, ...otherProps }) => {
  return (
    <Tooltip overlayClassName={classnames('cross-border-tooltip', overlayClassName)} zIndex={1080} placement={placement} {...otherProps}>
      {children}
    </Tooltip>
  )
}

export default Index
